import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { getChildrenReportRequest } from 'src/services/api.service'
import { useNotification } from 'src/contexts/notification.context'
import { useAuth } from 'src/contexts/auth.context'
// import { DateRangePicker } from 'react-dates';
import { Select } from 'src/components/select'
import { routes } from 'src/navigation/routes'

const ParentDashboard = () => {
  const { isLoading, wrapCallback } = useNotification()
  const { user } = useAuth()
  const [report, setReport] = useState({ tasks: [], students: [], scores: [] })
  const [filter, setFilter] = useState({
    period: 'month',
  })

  useEffect(() => {
    wrapCallback(async () => {
      await fetchReport()
    })
  }, [])

  const fetchReport = async () => {
    const result = await getChildrenReportRequest()
    setReport(result.data)
    return true
  }

  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  })
  const [focus, setFocus] = useState(null)

  const { startDate, endDate } = dateRange

  const handleOnDateChange = (startDate, endDate) =>
    setDateRange(startDate, endDate)

  const calcAverage = (pItems, id) => {
    const items = pItems.filter((x) => x)

    if (items.length <= 0)
      return <div key={id} className="report__line__col inactive" />

    return (
      <div key={id} className="report__line__col">
        {Math.round(items.reduce((val, acc) => acc + val, 0) / items.length) ||
          0}
      </div>
    )
  }

  const calcAverageTask = (scores, taskId) => {
    const items = Object.values(scores)
      .map((x) => x[taskId])
      .filter((x) => x)

    if (items.length <= 0)
      return <div key={taskId} className="report__line__col inactive" />

    console.log('items', items)

    return (
      <div key={taskId} className="report__line__col">
        {Math.round(items.reduce((acc, val) => acc + val, 0) / items.length)}
      </div>
    )
  }

  return (
    <>
      <h2 className="sectionHb-title">Dashboard</h2>
      <div className="sectionHb-block dashboardHb">
        <div className="sectionHb-block__wrap">
          <h2 className="sectionHb-title">
            Welcome,{' '}
            <span>
              {user.first_name} {user.last_name}
            </span>
          </h2>
          <div className="dashboardHb-img">
            <img src="/account/img/dashboard/img-2.svg" alt="" />
          </div>
          {/* <p>Welcome to your <b>Practithink</b> account! <br/>Create tests, sell printouts. Educate your children and help others.</p> */}
          <div className="practithinkHb">
            <span className="practithinkHb-title">
              Your Practithink starts here
            </span>
            <div className="row">
              <div className="practithinkHb-col col-lg-3 col-md-4 col-sm-6">
                <Link to={routes.children.index} className="practithinkHb-wrap">
                  <div className="practithinkHb-ico">
                    <img src="/account/img/dashboard/ico-5.svg" alt="" />
                  </div>
                  <span className="practithinkHb-subtitle">Add child</span>
                </Link>
              </div>
              <div className="practithinkHb-col col-lg-3 col-md-4 col-sm-6">
                <Link
                  to={routes.practices.index}
                  className="practithinkHb-wrap"
                >
                  <div className="practithinkHb-ico">
                    <img src="/account/img/dashboard/ico-6.svg" alt="" />
                  </div>
                  <span className="practithinkHb-subtitle">Create task</span>
                </Link>
              </div>
              <div className="practithinkHb-col col-lg-3 col-md-4 col-sm-6">
                <Link to={routes.profile.index} className="practithinkHb-wrap">
                  <div className="practithinkHb-ico">
                    <img src="/account/img/dashboard/ico-7.svg" alt="" />
                  </div>
                  <span className="practithinkHb-subtitle">Manage profile</span>
                </Link>
              </div>
              {/* <div className="practithinkHb-col col-lg-3 col-md-4 col-sm-6">
                <Link to="/awards" className="practithinkHb-wrap">
                  <div className="practithinkHb-ico"><img src="/account/img/dashboard/ico-8.svg" alt="" /></div>
                  <span className="practithinkHb-subtitle">Set goals and rewards</span>
                </Link>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <div className="report">
        <div className="report__inner">
          <div className="sort classroom__detail__sort classroom__detail__sort--allstudents">
            <div className="sort__inner">
              <div className="sort__left">
                <span className="report__sort__text" />
              </div>
              <div className="sort__right">
                <Select
                  black
                  placeholder="Period"
                  icon="/account/images/dest/icons/timetable--small.svg"
                  value={filter.period}
                  onChange={(item) => {
                    setFilter({ ...filter, period: item?.value })
                  }}
                  options={[
                    { label: 'This week', value: 'week' },
                    { label: 'This month', value: 'month' },
                  ]}
                />
              </div>
            </div>
          </div>

          <div className="report__table__wrapper">
            {!isLoading && (
              <div className="report__table">
                <div className="report__table__head">
                  <div className="report__table__head__left">
                    <div className="report__table__select__wrapper" />
                  </div>
                  <div className="report__table__head__right">
                    {report.tasks.map((x) => (
                      <div key={x.id} className="report__table__head__row">
                        <span className="report__table__head__text">
                          {x.title}
                        </span>
                        {/* <span className="report__table__head__notification">4</span> */}
                      </div>
                    ))}

                    {Object.values(report.scores).length > 0 && (
                      <div key="average" className="report__table__head__row">
                        <span className="report__table__head__text">
                          Average
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="report__table__body">
                  <div className="report__lines__wrapper active">
                    <div className="report__line report__line--main">
                      <div className="report__line__left">
                        <div className="report__line__title__wrapper">
                          <h3 className="report__line__title">Math</h3>
                          {/* <img src="/account/images/dest/report/arrow.svg" alt="arrow" className="report__line__arrow" /> */}
                        </div>
                      </div>

                      {Object.values(report.scores).length > 0 && (
                        <div className="report__line__right">
                          {report.tasks.map((x) =>
                            calcAverageTask(report.scores, x.id),
                          )}
                          <div
                            key="cross"
                            className="report__line__col inactive"
                          >
                            &nbsp;
                          </div>
                        </div>
                      )}
                    </div>

                    {report.students.map((x) => (
                      <div
                        key={x.id}
                        className="report__line report__line--hidden"
                      >
                        <div className="report__line__left">
                          <div className="report__line__title__wrapper">
                            <h3 className="report__line__title">
                              {x.first_name} {x.last_name}
                            </h3>
                          </div>
                        </div>

                        {Object.values(report.scores).length > 0 && (
                          <div className="report__line__right">
                            {Object.keys(report.scores[x.id]).map((k) => (
                              <div
                                key={k}
                                className={`report__line__col ${
                                  report.scores[x.id][k] === null
                                    ? 'inactive'
                                    : ' enabled'
                                }`}
                              >
                                {report.scores[x.id][k] === null
                                  ? ''
                                  : report.scores[x.id][k]}
                              </div>
                            ))}
                            {calcAverage(
                              Object.values(report.scores[x.id], x.id),
                            )}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default ParentDashboard
